
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.995.01a1 1 0 01.12 1.994l-.12.005H2v13.992H15.99v-5.997a1 1 0 011.994-.118l.005.119V16a2.016 2.016 0 01-1.851 1.993L15.99 18H1.999a2.016 2.016 0 01-1.993-1.851L0 16V2.01C0 .966.826.093 1.851.016L2 .01h5.996zM16.971 0a1 1 0 011.028 1.012l-.01.125v4.87a1 1 0 01-1.993.119l-.005-.12V3.423L6.703 12.71a1 1 0 01-1.494-1.325l.081-.088 9.288-9.288h-2.585a1 1 0 01-.119-1.993l.12-.006h4.866c.037-.005.074-.008.11-.01z"}})])
          )
        }
      }
    